import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737e3120"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projetos" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Projetos ", -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nomeDoProjeto",
  class: "label"
}, " Nome do Projeto ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button",
    type: "submit"
  }, " Salvar ")
], -1))
const _hoisted_6 = { class: "table is-fullwidth" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Nome")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nomeDoProjeto) = $event)),
          id: "nomeDoProjeto"
        }, null, 512), [
          [_vModelText, _ctx.nomeDoProjeto]
        ])
      ]),
      _hoisted_5
    ], 32),
    _createElementVNode("table", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projetos, (projeto) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: projeto.id
          }, [
            _createElementVNode("td", null, _toDisplayString(projeto.id), 1),
            _createElementVNode("td", null, _toDisplayString(projeto.nome), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}